(function () {
  'use strict';

  /* This asset is shared by every Albaki XCloud collection catalog.
     XCloud only hydrates selected facets on a hard load of its /a/search
     proxy route. If someone refreshes/bookmarks a clean public collection URL
     that contains XCloud filter/sort state, do one replace-navigation to the
     matching proxy route. Once XCloud initializes there, normalize only the
     visible browser URL back to /collections/{handle}. */
  function albakiCatalogHandle() {
    var el = document.querySelector('[data-albaki-collection-handle]');
    if (el) {
      var fromDom = (el.getAttribute('data-albaki-collection-handle') || '').trim();
      if (fromDom) return fromDom.toLowerCase();
    }

    var match = window.location.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|a\/search)\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function albakiCatalogNeedsProxyHydration() {
    var path = window.location.pathname;
    var match = path.match(/^\/((?:[a-z]{2}(?:-[a-z]{2})?)\/)?collections\/([^/?#]+)\/?$/i);
    if (!match) return null;

    var handle = albakiCatalogHandle();
    if (!handle || decodeURIComponent(match[2]).toLowerCase() !== handle) return null;

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }

    /* An older test build could accidentally create sort_by=on by reading the
       default value of XCloud's radio input. XCloud stores the real sort value
       on the surrounding label's data-filter-value attribute, so discard that
       invalid legacy value before deciding whether proxy hydration is needed. */
    if (params.get('sort_by') === 'on') {
      params.delete('sort_by');
      var repaired = window.location.pathname;
      var repairedQuery = params.toString();
      if (repairedQuery) repaired += '?' + repairedQuery;
      if (window.location.hash) repaired += window.location.hash;
      window.history.replaceState(window.history.state, '', repaired);
    }

    var hasState = false;
    params.forEach(function (_value, key) {
      if (key.indexOf('filter_') === 0 || key.indexOf('filter[') === 0 || key === 'sort_by' || key === 'page') {
        hasState = true;
      }
    });
    if (!hasState) return null;

    params.delete('cloud_search_section_id');
    var prefix = match[1] || '';
    var target = '/' + prefix + 'a/search/' + match[2];
    var query = params.toString();
    if (query) target += '?' + query;
    if (window.location.hash) target += window.location.hash;
    return target;
  }

  var albakiHydrationTarget = albakiCatalogNeedsProxyHydration();
  /* BISAC has intro, shelves and a spotlight outside the XCloud product grid.
     A full navigation to /a/search drops those sections. Its own pagination
     script hydrates saved filter/sort/page URLs by fetching product-grid only.
     Keep the original proxy behavior for Kids, Outcome, Discovery, etc. */
  var albakiIsBisacFullCollection = !!document.querySelector(
    '.akbisac-catalog[data-albaki-catalog]'
  );
  if (albakiHydrationTarget && !albakiIsBisacFullCollection) {
    window.location.replace(albakiHydrationTarget);
    return;
  }

  /* Keep the public collection URL clean while allowing XCloud to keep using
     /a/search/{handle} internally for AJAX section requests. Fetch/XHR URLs
     are intentionally untouched; only browser history URLs are normalized. */
  var albakiHistoryPushState = window.history.pushState.bind(window.history);
  var albakiHistoryReplaceState = window.history.replaceState.bind(window.history);

  function albakiCatalogPublicUrl(input) {
    var url;
    try {
      url = new URL(input || window.location.href, window.location.href);
    } catch (e) {
      return null;
    }

    var match = url.pathname.match(/^\/((?:[a-z]{2}(?:-[a-z]{2})?)\/)?a\/search\/([^/?#]+)\/?$/i);
    if (!match) return null;

    var handle = albakiCatalogHandle();
    if (handle && decodeURIComponent(match[2]).toLowerCase() !== handle) return null;

    url.pathname = '/' + (match[1] || '') + 'collections/' + match[2];
    url.searchParams.delete('cloud_search_section_id');
    if (url.searchParams.get('sort_by') === 'on') url.searchParams.delete('sort_by');
    return url.pathname + (url.search || '') + (url.hash || '');
  }

  function albakiNormalizeVisibleCatalogUrl() {
    var clean = albakiCatalogPublicUrl(window.location.href);
    if (!clean) return;
    albakiHistoryReplaceState(window.history.state, '', clean);
  }

  window.history.pushState = function (state, title, url) {
    albakiHistoryPushState(state, title, url);
    Promise.resolve().then(albakiNormalizeVisibleCatalogUrl);
  };

  window.history.replaceState = function (state, title, url) {
    albakiHistoryReplaceState(state, title, url);
    Promise.resolve().then(albakiNormalizeVisibleCatalogUrl);
  };

  /* On a full /a/search page load, let XCloud initialize first, then clean the
     visible URL without causing another navigation. */
  setTimeout(albakiNormalizeVisibleCatalogUrl, 0);

  var FILTER_ORDER = [
    'availability',
    'price',
    'age-group',
    'book-type',
    'format',
    'interest',
    'genre',
    'fiction-nonfiction',
    'condition',
    'large-print',
    'abridged',
    'discount'
  ];

  /* Stable fallback so the Albaki Sort by control can always render even when
     XCloud temporarily removes/rebuilds its native sort facet during AJAX. */
  var SORT_OPTIONS_FALLBACK = [
    { value: 'manual', label: 'Featured' },
    { value: 'most-relevant', label: 'Most relevant' },
    { value: 'best-selling', label: 'Best selling' },
    { value: 'title-ascending', label: 'Alphabetically, A-Z' },
    { value: 'title-descending', label: 'Alphabetically, Z-A' },
    { value: 'price-ascending', label: 'Price, low to high' },
    { value: 'price-descending', label: 'Price, high to low' },
    { value: 'created-ascending', label: 'Date, old to new' },
    { value: 'created-descending', label: 'Date, new to old' }
  ];

  /* Keep the Kids collection filter icons visually identical to the icons
     used on AlbakiReads' /search page. Keep this mapping in sync with
     assets/albaki-xcloud-search.js::filterIconSvg(). */
  function filterIconSvg(name) {
    var key = String(name || '').trim().toLowerCase();

    if (key.indexOf('price') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M14.7 8.6c-.7-.8-1.6-1.2-2.8-1.2-1.5 0-2.6.8-2.6 2 0 2.9 5.5 1.4 5.5 4.6 0 1.3-1.1 2.2-2.8 2.2-1.3 0-2.4-.4-3.2-1.3M12 5.6v12.8"/></svg>';
    }
    if (key.indexOf('availability') !== -1 || key.indexOf('stock') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 7.8 12 4l7.5 3.8v8.4L12 20l-7.5-3.8Z"/><path d="m4.7 7.9 7.3 3.7 7.3-3.7M12 11.6V20"/></svg>';
    }
    if (key.indexOf('format') !== -1 || key.indexOf('binding') !== -1 || key.indexOf('cover') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 4.5h9.2a3.8 3.8 0 0 1 3.8 3.8v11.2H8.7a3.2 3.2 0 0 1-3.2-3.2Z"/><path d="M8.7 4.5v15M8.7 16.5h9.8"/></svg>';
    }
    if (key.indexOf('brand') !== -1 || key.indexOf('vendor') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h16l-2 11H6L4 9ZM6 9l2-5h8l2 5"/><path d="M9 14h6"/></svg>';
    }
    if (key.indexOf('genre') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 5.5v6.2L12.8 20l6.7-6.7-8.3-7.8Z"/><circle cx="8.5" cy="9" r="1"/></svg>';
    }
    if (key.indexOf('subject') !== -1 || key.indexOf('topic') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 4 8 4-8 4-8-4Z"/><path d="m4 12 8 4 8-4M4 16l8 4 8-4"/></svg>';
    }
    if (key.indexOf('age') !== -1 || key.indexOf('audience') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3"/><circle cx="16.5" cy="9" r="2.3"/><path d="M3.8 19c.4-3.4 2.4-5.2 5.2-5.2s4.8 1.8 5.2 5.2M14 14.4c2.9-.8 5.5.9 6.1 3.8"/></svg>';
    }
    if (key.indexOf('condition') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="m8.4 12.2 2.3 2.3 4.9-5"/></svg>';
    }
    if (key.indexOf('abridged') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h12M6 9h8M6 13h12M6 17h7"/><path d="m16 16 3 3m0-3-3 3"/></svg>';
    }
    if (key.indexOf('large print') !== -1 || key.indexOf('print') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 18 9.8 6h2.4L17 18M6.8 14h8.4"/><path d="M18 7h2M19 6v2"/></svg>';
    }
    if (key.indexOf('discount') !== -1 || key.indexOf('sale') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 5.5v6.2L12.8 20l6.7-6.7-8.3-7.8Z"/><circle cx="8.5" cy="9" r="1"/><path d="m11 15 4-4"/></svg>';
    }
    if (key.indexOf('language') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M3.8 12h16.4M12 3.5c2.2 2.4 3.3 5.2 3.3 8.5S14.2 18.1 12 20.5M12 3.5C9.8 5.9 8.7 8.7 8.7 12s1.1 6.1 3.3 8.5"/></svg>';
    }
    if (key.indexOf('publisher') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 20V8l7-4 7 4v12M9 20v-5h6v5M8 10h2M14 10h2"/></svg>';
    }
    if (key.indexOf('author') !== -1) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.2"/><path d="M5.5 19c.6-4.1 3-6.2 6.5-6.2s5.9 2.1 6.5 6.2"/></svg>';
    }

    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M7 12h10M9 17h6"/><circle cx="8" cy="7" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="11" cy="17" r="1"/></svg>';
  }

  function currentHandle() {
    return albakiCatalogHandle();
  }

  function normalize(value) {
    return (value || '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function canonicalName(raw) {
    var n = normalize(raw);
    if (n === 'availability' || n === 'stock') return 'availability';
    if (n === 'price' || n.indexOf('price') !== -1) return 'price';
    if (n === 'age group' || n === 'kids age group' || n === 'age') return 'age-group';
    if (n === 'book type' || n === 'kids book type' || n === 'type') return 'book-type';
    if (n === 'gift category' || n === 'non book category' || n === 'nonbook category') return 'gift-category';
    if (n === 'product type' || n === 'gift type' || n === 'merchandise type') return 'product-type';
    if (n === 'brand' || n === 'brands' || n === 'vendor' || n === 'vendors') return 'brand';
    if (n === 'format' || n === 'binding' || n === 'binding type') return 'format';
    if (n === 'interest' || n === 'kids interest') return 'interest';
    if (n === 'genre') return 'genre';
    if (n === 'subgenre' || n === 'sub genre' || n === 'bisac minor subject' || n === 'bisac minor' || n === 'minor subject' || n === 'topic' || n === 'subject' || n === 'business topic' || n === 'business topics' || n === 'personal growth topic' || n === 'personal growth topics' || n === 'self help topic' || n === 'self-help topic' || n === 'health topic' || n === 'health topics' || n === 'health & wellness topic' || n === 'health and wellness topic' || n === 'health & fitness topic' || n === 'health and fitness topic' || n === 'study & test topic' || n === 'study and test topic' || n === 'study test topic' || n === 'study topic' || n === 'test prep topic' || n === 'test preparation topic') return 'subgenre';
    if (n === 'author' || n === 'authors') return 'author';
    if (n === 'publisher' || n === 'publishers') return 'publisher';
    if (n === 'language' || n === 'languages') return 'language';
    if (n === 'fiction / nonfiction' || n === 'fiction / non fiction' || n === 'fiction nonfiction' || n === 'content type' || n === 'kids content type') return 'fiction-nonfiction';
    if (n === 'condition' || n === 'item condition') return 'condition';
    if (n === 'large print' || n === 'large print flag') return 'large-print';
    if (n === 'abridged' || n === 'abridged flag') return 'abridged';
    if (n === 'discount' || n === 'discount filter') return 'discount';
    return '';
  }

  function topLevelGroups(sidebar) {
    return Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-name]')).filter(function (el) {
      var parent = el.parentElement;
      while (parent && parent !== sidebar) {
        if (parent.hasAttribute && parent.hasAttribute('data-filter-name')) return false;
        parent = parent.parentElement;
      }
      return true;
    });
  }

  function injectIcon(group, filterName) {
    var target = group.querySelector('.cloud-search-filter__name') || group.firstElementChild;
    if (!target || target.querySelector('.albaki-filter-icon')) return;
    var span = document.createElement('span');
    span.className = 'albaki-filter-icon';
    span.innerHTML = filterIconSvg(filterName);
    target.insertBefore(span, target.firstChild);
  }

  function optionLabel(group, input) {
    var label = null;
    if (input.id) {
      try { label = group.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]'); } catch (e) {}
    }
    if (!label) label = input.closest('label');
    var text = label ? label.textContent : input.getAttribute('aria-label');
    return (text || input.value || '').replace(/\s*\(\d[\d,]*\)\s*$/, '').trim();
  }

  function readCloudData() {
    var el = document.getElementById('cloudsearch-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function findSortGroup() {
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-filter-name]'));
    return groups.find(function (g) {
      var n = normalize(g.getAttribute('data-filter-name') || '');
      return n === 'sort by' || n === 'sort';
    }) || null;
  }

  function sortOptionsFromData() {
    var data = readCloudData();
    if (!data || !Array.isArray(data.facets)) return [];
    var facet = data.facets.find(function (f) {
      return f && (f.id === 'sort' || normalize(f.name || '') === 'sort by');
    });
    if (!facet || !Array.isArray(facet.options)) return [];
    return facet.options.filter(function (o) { return o && o.enabled !== false; }).map(function (o) {
      return { value: String(o.value), label: String(o.name || o.value) };
    });
  }

  function nativeSortOptions(sortGroup) {
    if (!sortGroup) return [];

    /* XCloud does not put the sort key in input.value. Its inputs use the
       browser default value "on" and the real value lives on the surrounding
       label as data-filter-value. Read that attribute instead. */
    var labels = Array.prototype.slice.call(sortGroup.querySelectorAll('[data-filter-value]'));
    if (labels.length) {
      return labels.map(function (label) {
        var value = label.getAttribute('data-filter-value');
        var input = label.querySelector('input');
        return { value: String(value || ''), label: optionLabel(sortGroup, input || label) };
      }).filter(function (o) { return !!o.value; });
    }

    var nativeSelect = sortGroup.querySelector('select');
    if (nativeSelect) {
      return Array.prototype.slice.call(nativeSelect.options).map(function (option) {
        return { value: String(option.value), label: (option.textContent || option.value || '').trim() };
      });
    }
    return [];
  }

  function currentSortValue(sortGroup) {
    if (sortGroup) {
      var checked = sortGroup.querySelector('[data-filter-value] input:checked');
      if (checked) {
        var checkedLabel = checked.closest('[data-filter-value]');
        if (checkedLabel) return String(checkedLabel.getAttribute('data-filter-value') || '');
      }
      var nativeSelect = sortGroup.querySelector('select');
      if (nativeSelect && nativeSelect.value) return String(nativeSelect.value);
    }

    var data = readCloudData();
    if (data && data.sort && String(data.sort) !== 'on') return String(data.sort);

    try {
      var fromUrl = new URL(window.location.href).searchParams.get('sort_by');
      if (fromUrl && fromUrl !== 'on') return String(fromUrl);
    } catch (e) {}
    return 'best-selling';
  }

  function findNativeSortChoice(sortGroup, value) {
    if (!sortGroup) return null;
    var choices = Array.prototype.slice.call(sortGroup.querySelectorAll('[data-filter-value]'));
    return choices.find(function (choice) {
      return String(choice.getAttribute('data-filter-value') || '') === String(value);
    }) || null;
  }

  function waitForNativeSortChoice(sortGroup, value, timeoutMs) {
    return new Promise(function (resolve) {
      var immediate = findNativeSortChoice(sortGroup, value);
      if (immediate) {
        resolve(immediate);
        return;
      }

      var finished = false;
      var observer = new MutationObserver(function () {
        var choice = findNativeSortChoice(sortGroup, value);
        if (!choice || finished) return;
        finished = true;
        observer.disconnect();
        resolve(choice);
      });
      observer.observe(sortGroup, { childList: true, subtree: true });

      window.setTimeout(function () {
        if (finished) return;
        finished = true;
        observer.disconnect();
        resolve(findNativeSortChoice(sortGroup, value));
      }, timeoutMs || 800);
    });
  }

  function applyNativeSort(value) {
    var sortGroup = findSortGroup();
    if (!sortGroup) return Promise.resolve(false);

    function clickChoice(choice) {
      if (!choice) return false;
      var input = choice.querySelector('input');
      if (input) {
        input.click();
        return true;
      }
      choice.click();
      return true;
    }

    var choice = findNativeSortChoice(sortGroup, value);
    if (choice) return Promise.resolve(clickChoice(choice));

    /* XCloud lazily creates Sort by values only after its collapsed native
       Sort by heading is expanded. Programmatically expand that real XCloud
       group, wait for the data-filter-value labels, then click the same native
       control a customer would click. This preserves XCloud AJAX behavior. */
    var heading = sortGroup.querySelector('.cloud-search-filter__name') || sortGroup.firstElementChild;
    if (heading) heading.click();

    return waitForNativeSortChoice(sortGroup, value, 1000).then(function (lazyChoice) {
      return clickChoice(lazyChoice);
    });
  }

  function buildSortProxy(sortGroup) {
    var slot = document.querySelector('[data-albaki-sort-slot]');
    if (!slot) return;

    if (sortGroup) sortGroup.classList.add('albaki-kids-native-sort-group');

    var options = nativeSortOptions(sortGroup);
    if (!options.length) options = sortOptionsFromData();
    if (!options.length) options = SORT_OPTIONS_FALLBACK.slice();

    var proxy = slot.querySelector('.albaki-kids-sort-proxy');
    if (!proxy) {
      proxy = document.createElement('div');
      proxy.className = 'albaki-kids-sort-proxy';
      proxy.innerHTML = '<label class="albaki-kids-sort-proxy__label" for="AlbakiKidsSort">Sort by</label><select id="AlbakiKidsSort" class="albaki-kids-sort-proxy__select" aria-label="Sort books"></select>';
      slot.innerHTML = '';
      slot.appendChild(proxy);

      proxy.querySelector('select').addEventListener('change', function (event) {
        var selectEl = event.target;
        var requested = selectEl.value;
        var previous = currentSortValue(findSortGroup());

        applyNativeSort(requested).then(function (handled) {
          if (handled) return;

          /* Never navigate/reload as a sort fallback. If XCloud does not expose
             the requested native option, restore the last known sort and leave
             the current results intact. */
          selectEl.value = previous || 'best-selling';
          if (window.console && console.warn) {
            console.warn('[Albaki Catalog] XCloud native sort option was not available:', requested);
          }
        });
      });
    }

    var select = proxy.querySelector('select');
    var signature = options.map(function (o) { return o.value + '::' + o.label; }).join('|');
    if (select.getAttribute('data-options-signature') !== signature) {
      select.innerHTML = '';
      options.forEach(function (o) {
        var option = document.createElement('option');
        option.value = o.value;
        option.textContent = o.label;
        select.appendChild(option);
      });
      select.setAttribute('data-options-signature', signature);
    }

    var current = currentSortValue(sortGroup);
    if (current && select.value !== current) select.value = current;
  }

  function isNativeClearControl(el) {
    if (!el || el.classList.contains('albaki-kids-clear-all')) return false;
    var t = normalize(el.textContent || el.getAttribute('aria-label') || '');
    return t === 'clear all filters' || t === 'clear all';
  }

  function findNativeClearControls(sidebar) {
    if (!sidebar) return [];
    return Array.prototype.slice.call(sidebar.querySelectorAll('a, button, [role="button"]')).filter(isNativeClearControl);
  }

  function setupClearAll(sidebar, hasApplied) {
    var slot = document.querySelector('[data-albaki-clear-slot]');
    if (!slot || !sidebar) return;

    var nativeControls = findNativeClearControls(sidebar);
    nativeControls.forEach(function (el) { el.classList.add('albaki-kids-native-clear-hidden'); });

    var proxy = slot.querySelector('.albaki-kids-clear-all');
    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'albaki-kids-clear-all';
      proxy.textContent = 'Clear all';
      proxy.addEventListener('click', function () {
        var currentSidebar = document.getElementById('cloud_search_filters_sidebar');
        var currentControls = findNativeClearControls(currentSidebar);
        if (currentControls.length) {
          currentControls[0].click();
          return;
        }

        /* Fallback: remove active filters one by one if XCloud temporarily
           omits its own Clear all control during an AJAX repaint. */
        var removers = currentSidebar ? Array.prototype.slice.call(currentSidebar.querySelectorAll('.cloud-search-applied-filter button, .cloud-search-applied-filter [role="button"], .cloud-search-applied-filter--rounded button, .cloud-search-applied-filter--rounded [role="button"]')) : [];
        if (removers.length) removers[0].click();
      });
      slot.appendChild(proxy);
    }
    proxy.hidden = !hasApplied;
  }

  function enhancePriceFilter(sidebar) {
    if (!sidebar) return;
    var group = sidebar.querySelector('[data-albaki-filter-key="price"]');
    if (!group) return;

    /* XCloud's price facet currently renders a bordered currency wrapper and
       then a second bordered input inside it. Tag the two wrappers so CSS can
       collapse that into the single-field treatment from the approved design. */
    var fields = Array.prototype.slice.call(group.querySelectorAll('input[type="text"], input[type="number"]')).slice(0, 2);
    var wrappers = fields.map(function (input) {
      var wrapper = input.parentElement;
      if (wrapper && wrapper !== group) wrapper.classList.add('albaki-price-field');
      return wrapper;
    }).filter(Boolean);

    if (wrappers.length === 2 && wrappers[0].parentElement && wrappers[0].parentElement === wrappers[1].parentElement) {
      wrappers[0].parentElement.classList.add('albaki-price-fields-row');
    }

    /* Hide only leaf currency readouts such as "$7.17 USD" / "$264.77 USD".
       Do not hide editable fields, headings, or any element that owns controls. */
    Array.prototype.slice.call(group.querySelectorAll('*')).forEach(function (el) {
      if (el.children.length || el.matches('input, button, a')) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^[\$€£]?\s*\d[\d,.]*\s*(?:USD|CAD|GBP|EUR)?$/i.test(text) && /(?:USD|CAD|GBP|EUR)$/i.test(text)) {
        el.classList.add('albaki-price-readout');
      }
    });
  }

  function enhance() {
    var sidebar = document.getElementById('cloud_search_filters_sidebar');
    var sortGroup = findSortGroup();

    if (sidebar) {
      var groups = topLevelGroups(sidebar);

      groups.forEach(function (group) {
        var raw = group.getAttribute('data-filter-name') || '';
        var normalized = normalize(raw);
        var key = canonicalName(raw);

        var isSort = normalized === 'sort by' || normalized === 'sort';
        var catalogRoot = document.querySelector('[data-albaki-catalog], [data-kids-catalog]');
        var isKidsCatalog = !!(catalogRoot && catalogRoot.hasAttribute('data-kids-catalog'));
        var explicitlyHidden = isKidsCatalog && (normalized === 'target audience' || normalized === 'language');

        if (isSort) {
          sortGroup = group;
          group.classList.remove('albaki-kids-sort-group');
          group.classList.add('albaki-kids-native-sort-group');
          return;
        }

        if (!key || explicitlyHidden) {
          group.classList.add('albaki-kids-cloud-hidden');
          return;
        }

        group.classList.remove('albaki-kids-cloud-hidden');
        group.classList.add('albaki-kids-filter-group');
        group.setAttribute('data-albaki-filter-key', key);
        injectIcon(group, raw);
      });

      /*
       * Do not reorder XCloud facet groups here.
       * XCloud's admin controls the customer-facing filter order. Earlier
       * versions of this file forced FILTER_ORDER (including Price in slot 2),
       * which overrode the order configured in the app.
       */

      sidebar.querySelectorAll('*').forEach(function (el) {
        var text = normalize(el.textContent);
        if ((text === 'filters' || text === 'filter & refine') && el.children.length <= 2) {
          el.classList.add('albaki-kids-cloud-hidden');
        }
      });

      enhancePriceFilter(sidebar);
    }

    var catalog = document.querySelector('[data-albaki-catalog], [data-kids-catalog]');
    var root = document.getElementById('cloud_search_filters_root');
    var urlHasApplied = false;
    try {
      new URL(window.location.href).searchParams.forEach(function (_value, key) {
        if (key.indexOf('filter_') === 0 || key.indexOf('filter[') === 0) urlHasApplied = true;
      });
    } catch (e) {}

    var hasApplied = !!(
      urlHasApplied ||
      (root && root.querySelector('.cloud-search-applied-filter, .cloud-search-applied-filter--rounded, [class*="applied-filter"]')) ||
      (sidebar && sidebar.querySelector('.cloud-search-applied-filter, .cloud-search-applied-filter--rounded, [class*="applied-filter"]'))
    );
    if (catalog) catalog.classList.toggle('has-active-filters', hasApplied);

    if (sidebar) setupClearAll(sidebar, hasApplied);
    buildSortProxy(sortGroup);

    var data = readCloudData();
    document.querySelectorAll('[data-albaki-results-count]').forEach(function (countEl) {
      /* Prefer the server-rendered paginate total on the freshly returned
         product-grid section. cloudsearch-data can be stale after XCloud's
         section extractor has removed its sibling script from the response. */
      var n = Number(countEl.getAttribute('data-albaki-results-count'));
      if (Number.isNaN(n) && data && typeof data.total === 'number') n = data.total;
      if (!Number.isNaN(n)) countEl.textContent = countEl.closest('.akbisac-catalog') ? 'Total ' + n.toLocaleString() + ' Items' : 'Total: ' + n.toLocaleString();
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      enhance();
    });
  }

  document.addEventListener('DOMContentLoaded', enhance);
  window.addEventListener('popstate', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  enhance();
})();
